<template>
  <i
    :class="[ {'active': internalIsFavorite}, iconClass ]"
    class="ddi favorite-button"
    @click="internalIsFavorite = !internalIsFavorite"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FavoriteButton',

  props: {
    isFavorite: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:isFavorite'],

  computed: {
    internalIsFavorite: {
      get(): any {
        return this.isFavorite
      },
      set(val: any) {
        if (this.isFavorite !== val) {
          this.$emit('update:isFavorite', val)
        }
      },
    },
    iconClass(): string {
      return this.isFavorite ? 'ddi-star-filled' : 'ddi-star'
    },
  },
})
</script>

<style lang="scss">
.favorite-button {
  &.ddi.ddi-star,
  &.ddi.ddi-star-filled {
    color: var(--color-text-third);

    &.active {
      color: $color--orange-40;
    }

    &:hover {
      color: $color--orange-40;
      cursor: pointer;
    }
  }
}
</style>
